module.exports = __webpack_public_path__ + "img/img04.eeb26270.jpg";